import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DynamicFormsFieldComponent from '../DynamicFormField';
import ModalCloneSection from '../ModalCloneSection';
import ModalRemoveSection from '../ModalRemoveSection';
import { LfaContextAPIShape } from '../../../Context/LfaContext';
import DFFCloneService from '../../../Services/DFFCloneService';

import './style.scss';
import Icon from '../../Common/Icon';
import Utils from '../../../Services/Utils';
import History from '../../../Services/History';
import ConfigService from '../../../Services/api/Config';
import { ReactComponent as DeleteIcon } from '../../../../img/icon-delete.svg';
import { ReactComponent as OpenIcon } from '../../../../img/expand-closed.svg';
import { ReactComponent as CloseIcon } from '../../../../img/expand-open.svg';
import { ReactComponent as CloneIcon } from '../../../../img/icon-clone.svg';

class SectionComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalCloneVisible: false,
      modalDeleteVisible: false
    };
  }

  componentDidMount() {
    History.singleton().register(
      'modalCloneSection',
      () => {
        this.onPressedClone();
      },
      () => {
        this.onPressedModalCloneClose();
      }
    );
    History.singleton().register(
      'modalDeleteSection',
      () => {
        this.onPressedDelete();
      },
      () => {
        this.onPressedModalDeleteClose();
      }
    );
  }

  componentWillUnmount() {
    History.singleton().unregister('modalCloneSection');
    History.singleton().unregister('modalDeleteSection');
  }

  onPressedClone = () => {
    const { configuration } = this.props;
    if (configuration.disabled) {
      return;
    }
    History.singleton().show('modalCloneSection');
    this.setState({ modalCloneVisible: true });
  };

  onPressedDelete = () => {
    const { configuration } = this.props;
    if (configuration.disabled) {
      return;
    }
    History.singleton().show('modalDeleteSection');
    this.setState({ modalDeleteVisible: true });
  };

  onPressedModalCloneClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalCloneVisible: false });
  };

  onPressedModalDeleteClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalDeleteVisible: false });
  };

  onPressedCollapse = () => {
    const { api, configuration, data } = this.props;

    api.onSectionCollapsed(!data.collapsed, configuration.id);
  };

  cloneSection = async () => {
    const { api, configuration } = this.props;
    if (configuration.disabled) {
      return;
    }
    const label = api.getLabelGreatestSection(configuration.id);
    await DFFCloneService.cloneSection(api, configuration, label);
  };

  isFieldVisible = () => {
    const { data } = this.props;

    if (data.visibility === false) {
      return false;
    }

    return true;
  };


  render() {
    const {
      children,
      configuration,
      data,
      errors,
      api,
      descriptionAsIcon,
      showTriggerConditionMet,
      isCompact,
      className,
      scoreFormType,
      headerSection
    } = this.props;

    const { modalCloneVisible, modalDeleteVisible } = this.state;

    if (this.isFieldVisible() === false) {
      return null;
    }

    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;
    const scoreVisible = scoreFormType > 0 && scoreType > 0;
    let visibleChildren = !configuration.hide;
    if (!visibleChildren) {
      configuration.fields.order.map((childId) => {
        if (data && data.fields && data.fields[childId] && data.fields[childId].visibility) {
          visibleChildren = true;
        }
      });
    }
    const showBlock = visibleChildren && (configuration.cloneEnabled || configuration.originId || scoreVisible > 0);
    const columns =
      !Utils.isNull(configuration.columns) && !Utils.isNull(configuration.columns.value) ? configuration.columns.value : configuration.columns;
    const isTotal = className && className.includes('Section_Total');
    //need to update the complete in language same as preview language by using common function
    return (
      <div
        className={classNames('WrapperSection', className, {
          WrapperSection_Collapsed: Boolean(data.collapsed),
          WrapperSection_Hidden: Boolean(configuration.hide)
        })}>
        <div
          style={{
            color: isTotal ? ConfigService.getColor('secondaryColor') : null,
            fontSize: configuration.fontSize ? configuration.fontSize.label : null,
            backgroundColor: ConfigService.getColor('tertiaryColor', 0.3)
          }}
          className={classNames('WrapperSection_Label', {
            Bold: Boolean(configuration.bold),
            Italic: Boolean(configuration.italic)
          })}
          onClick={this.onPressedCollapse}>
          {api ? api.getFieldsVerbiage(configuration, 'label') : configuration.label}
          {headerSection && headerSection()}
        </div>
        {data.collapsed === false && (
          <div
            className={classNames('WrapperSection_Content', 'WrapperSection_Content_' + columns, {
              WrapperSection_Content_Clone: showBlock && configuration.hide
            })}>
            {configuration.fields.order.map((fieldId) => {
              return (
                <DynamicFormsFieldComponent
                  descriptionAsIcon={descriptionAsIcon}
                  showTriggerConditionMet={showTriggerConditionMet}
                  isCompact={isCompact}
                  key={fieldId}
                  onFieldAdded={this.props.onFieldAdded}
                  onPressedWorkOrder={this.props.onPressedWorkOrder}
                  configuration={{...configuration.fields.items[fieldId], 'previewLanguage': configuration.previewLanguage}}
                  sectionColumns = {configuration.columns}
                  data={data.fields[fieldId] || {}}
                  error={errors.fields[fieldId] || ''}
                  errorTrigger={errors.fields[fieldId + 'trigger'] || ''}
                  api={this.props.api}
                />
              );
            })}
            {showBlock && configuration.hide && (
              <div className="WrapperSection_Actions_Inline Align_Right">
                {configuration.originId && (
                  <Icon className="Inline_Delete" width="15" height="15" color="secondaryColor" onClick={this.onPressedDelete}>
                    <CloseIcon alt="expand-open" />
                  </Icon>
                )}
                {configuration.cloneEnabled && (
                  <Icon className="Inline_Clone" width="15" height="15" color="secondaryColor" onClick={this.cloneSection}>
                    <OpenIcon alt="expand-closed" />
                  </Icon>
                )}
              </div>
            )}
            {children}
          </div>
        )}
        {showBlock && (
          <div className="WrapperSection_Actions Table Center" style={{ color: ConfigService.getColor('tertiaryColor') }}>
            {configuration.cloneEnabled && !configuration.hide && (
              <div className="Right SizedBox">
                <div className="Pointer" onClick={this.onPressedClone}>
                  <Icon width="16" height="16" color="secondaryColor">
                    <CloneIcon width="16px" height="16px" alt="icon-clone" />
                  </Icon>
                </div>
              </div>
            )}
            {configuration.originId && !configuration.hide && (
              <div className="Right">
                <div className="Pointer" onClick={this.onPressedDelete}>
                  <Icon width="17" height="18" color="errorColor">
                    <DeleteIcon alt="icon-delete" />
                  </Icon>
                </div>
              </div>
            )}
            {scoreVisible && (
              <div className="Left">
                <span>Section score:</span>
                {data.score}
              </div>
            )}
          </div>
        )}
        {modalCloneVisible && (
          <ModalCloneSection
            configuration={configuration}
            label={api.getLabelGreatestSection(configuration.id)}
            onClose={this.onPressedModalCloneClose}
            api={api}
          />
        )}
        {modalDeleteVisible && <ModalRemoveSection configuration={configuration} onClose={this.onPressedModalDeleteClose} api={this.props.api} />}
      </div>
    );
  }
}

SectionComponent.propTypes = {
  descriptionAsIcon: PropTypes.bool,
  showTriggerConditionMet: PropTypes.bool,
  isCompact: PropTypes.bool,
  className: PropTypes.string,
  configuration: PropTypes.object.isRequired,
  scoreFormType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  api: LfaContextAPIShape,
  onFieldAdded: PropTypes.func.isRequired,
  onPressedWorkOrder: PropTypes.func.isRequired,
  headerSection: PropTypes.func
};

export default SectionComponent;
